import { useEffect, useState } from 'react';
import PaymentConverterService from '~/api-services/PaymentConverterService';
import {ConfigExtraData} from '~/api-services/PaymentConverterService/types';

export const useAddFundsExtra = () => {
    const [configDataExtra, setConfigDataExtra] = useState<ConfigExtraData>();

    useEffect(() => {
        loadData();
    }, []);

    async function loadData() {
        const { status, data } = await PaymentConverterService.getConfigExtra();
        if (status === 200 && data.status) {
            setConfigDataExtra(data.returnData);
        }
    }

    return {
        configDataExtra,
    };
};
